"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notify = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _polished = require("polished");

var _theme = require("./theme");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      cursor: pointer;\n\n      &:hover {\n        &:after {\n          -webkit-animation-play-state: paused;\n          -moz-animation-play-state: paused;\n          -o-animation-play-state: paused;\n          animation-play-state: paused;\n        }\n      }\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    &:before{\n        content: '", "';\n        font-family: 'flexisaf', ", ";\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: #fff;\n        position: absolute;\n        top:-3px;\n        left: -30px;\n        height: calc(100% - 5px);\n        width: 30px;\n        background: ", ";\n        opacity: 0.8;\n        border-radius: ", " 0 0 ", ";\n    }\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        animation-name: ", ";\n        animation-duration: ", "s;\n        animation-timing-function: linear;\n        animation-iteration-count: 1;\n        animation-fill-mode: forwards;\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  background: #fff;\n  box-sizing: border-box;\n  padding: 15px;\n  max-width: 350px;\n  margin: 10px;\n\n  font-family: ", ";\n  border-radius: 0 0 ", " ", ";\n  font-size: ", ";\n  min-width: ", ";\n  max-width: ", ";\n\n  margin: 10px\n    ", ";\n\n  box-shadow: 3px 6px 10px\n    ", ";\n\n  border-top: 3px solid\n    ", ";\n  color: ", ";\n\n  animation-name: ", ";\n  animation-duration: 0.2s;\n  animation-timing-function: linear;\n  animation-iteration-count: 1;\n  animation-fill-mode: both;\n\n  & i {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    position: absolute;\n    top: -3px;\n    left: -30px;\n    height: calc(100% - 5px);\n    width: 30px;\n    background: ", ";\n    opacity: 0.8;\n    border-radius: 3px 0 0 3px;\n  }\n\n  &:after {\n    position: absolute;\n    content: '';\n    opacity: 0.8;\n    display: block;\n    top: -3px;\n    left: 0;\n    height: 3px;\n    width: 0;\n    background: ", ";\n    ", "\n  }\n\n  ", "\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        bottom: 0;\n        left: 0;\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        bottom: 0;\n        right: 0;\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        top: 0;\n        left: 0;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        top: 0;\n        right: 0;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  z-index: 1200;\n  position: fixed;\n\n    \n\n    ", "\n    ", "\n    ", "\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  from{\n      right: -50%;\n  }\n  to {\n    right: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  to {\n    width: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Load = (0, _styledComponents.keyframes)(_templateObject());
var ShowUp = (0, _styledComponents.keyframes)(_templateObject2());
var NoticeWrapper = (0, _styledComponents["default"])('div').attrs({
  className: 'flexi-notification-container'
})(_templateObject3(), function (props) {
  return props.position === 'top-right' && (0, _styledComponents.css)(_templateObject4());
}, function (props) {
  return props.position === 'top-left' && (0, _styledComponents.css)(_templateObject5());
}, function (props) {
  return props.position === 'bottom-right' && (0, _styledComponents.css)(_templateObject6());
}, function (props) {
  return props.position === 'bottom-left' && (0, _styledComponents.css)(_templateObject7());
});
var Toast = (0, _styledComponents["default"])('div').attrs({
  className: 'flexi-notification-message'
})(_templateObject8(), _theme.FlexTheme.PrimaryFontFamily, _theme.FlexTheme.PrimaryRadius, _theme.FlexTheme.PrimaryRadius, _theme.FlexTheme.PrimaryFontSize, function (props) {
  return props.minWidth;
}, function (props) {
  return props.maxWidth;
}, function (props) {
  return (props.status || props.realIcon) && (props.position === 'bottom-left' || props.position === 'top-left') ? '40px' : '10px';
}, function (props) {
  return (0, _polished.transparentize)(0.8, (0, _polished.darken)(0.35, props.color ? props.color : _theme.FlexTheme.PrimaryColor));
}, function (props) {
  return (0, _polished.lighten)(0.4, props.color ? props.color : _theme.FlexTheme.PrimaryColor);
}, function (props) {
  return (0, _polished.darken)(0.45, props.color ? props.color : _theme.FlexTheme.PrimaryColor);
}, ShowUp, function (props) {
  return props.color ? props.color : _theme.FlexTheme.PrimaryColor;
}, function (props) {
  return props.color ? props.color : _theme.FlexTheme.PrimaryColor;
}, function (props) {
  return props.animation && (0, _styledComponents.css)(_templateObject9(), Load, function (props) {
    return props.duration / 1000;
  });
}, function (props) {
  return props.status && (0, _styledComponents.css)(_templateObject10(), function (props) {
    return props.icon;
  }, _theme.FlexTheme.PrimaryFontFamily, function (props) {
    return props.color ? props.color : _theme.FlexTheme.PrimaryColor;
  }, _theme.FlexTheme.PrimaryRadius, function (props) {
    return props.theme.PrimaryRadius;
  });
}, function (props) {
  return props.hover && (0, _styledComponents.css)(_templateObject11());
});

var Timer = /*#__PURE__*/function () {
  function Timer(callback, delay) {
    _classCallCheck(this, Timer);

    this.timerId = null;
    this.start = Date.now();
    this.remaining = delay;
    this.callback = callback;
    this.resume();
  }

  _createClass(Timer, [{
    key: "pause",
    value: function pause() {
      window.clearTimeout(this.timerId);
      this.remaining -= Date.now() - this.start;
    }
  }, {
    key: "resume",
    value: function resume() {
      this.start = Date.now();
      window.clearTimeout(this.timerId);
      this.timerId = window.setTimeout(this.callback, this.remaining);
    }
  }, {
    key: "kill",
    value: function kill() {
      window.clearTimeout(this.timerId);
    }
  }]);

  return Timer;
}();

var CreateNotificationContainers = function CreateNotificationContainers(message, newOption) {
  var id = "flexi-notification-wrapper-".concat(newOption.position);
  var box = document.createElement('div');
  document.getElementById('flexi-layout').appendChild(box);
  box.setAttribute('id', id);

  _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(NoticeWrapper, {
    position: newOption.position,
    id: "flexi-notification-".concat(newOption.position)
  }), document.getElementById(id));

  notifyFunction(message, newOption);
};

var hashCode = function hashCode(props) {
  var hash = 0;

  if (props.length === 0) {
    return hash;
  }

  for (var i = 0; i < props.length; i++) {
    var _char = props.charCodeAt(i);

    hash = (hash << 5) - hash + _char;
    hash = hash & hash; // Convert to 32bit integer
  }

  return hash.toString();
};

var notifyFunction = function notifyFunction(message, options) {
  var date = new Date();
  var id = hashCode(date.toISOString());
  var box = document.createElement('div');
  document.getElementById("flexi-notification-".concat(options.position)).appendChild(box);
  box.setAttribute('id', id);
  var timer = new Timer(function () {
    options.autoClose && document.getElementById(id).remove();
  }, options.duration);

  switch (options.status) {
    case 'success':
      options.color = _theme.FlexTheme.PrimaryGreen;
      options.icon = options.icon ? options.icon : 'S';
      break;

    case 'error':
      options.color = _theme.FlexTheme.PrimaryRed;
      options.icon = options.icon ? options.icon : 'E';
      break;

    case 'info':
      options.color = _theme.FlexTheme.PrimaryBlue;
      options.icon = options.icon ? options.icon : 'I';
      break;

    case 'warning':
      options.color = _theme.FlexTheme.PrimaryOrange;
      options.icon = options.icon ? options.icon : 'W';
      break;

    default:
      options.color = options.color ? options.color : _theme.FlexTheme.PrimaryGreen;
      options.icon = !options.icon && null;
  }

  _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(Toast, {
    hover: options.pauseOnHover,
    animation: options.autoClose,
    duration: options.duration,
    onMouseOver: function onMouseOver() {
      return options.pauseOnHover && timer.pause();
    },
    onMouseLeave: function onMouseLeave() {
      return options.pauseOnHover && timer.resume();
    },
    position: options.position,
    status: options.status,
    icon: options.icon,
    realIcon: options.realIcon,
    minWidth: options.minWidth,
    maxWidth: options.maxWidth,
    onClick: function onClick() {
      document.getElementById(id).remove();
      timer.kill();
    },
    color: options.color
  }, options.realIcon && /*#__PURE__*/_react["default"].createElement("i", {
    className: options.realIcon
  }), message), document.getElementById(id));
};

var Notify = function Notify(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var newOption = _objectSpread(_objectSpread({}, defaultOptionsProps), options);

  document.getElementById("flexi-notification-wrapper-".concat(newOption.position)) ? notifyFunction(message, newOption) : CreateNotificationContainers(message, newOption);
};

exports.Notify = Notify;
var defaultOptionsProps = {
  position: 'top-right',
  duration: 5000,
  pauseOnHover: true,
  autoClose: true,
  status: null,
  realIcon: null,
  minWidth: '250px',
  maxWidth: '300px'
};
Notify.defaultProps = _objectSpread({
  options: _objectSpread({}, defaultOptionsProps)
}, defaultOptionsProps);
Notify.propTypes = {
  options: _propTypes["default"].array,
  message: _propTypes["default"].string,
  position: _propTypes["default"].string,
  minWidth: _propTypes["default"].string,
  maxWidth: _propTypes["default"].string,
  duration: _propTypes["default"].number,
  pauseOnHover: _propTypes["default"].bool,
  autoClose: _propTypes["default"].bool,
  status: _propTypes["default"].string,
  realIcon: _propTypes["default"].any
};